import { from } from 'rxjs';
import axios from 'axios';

export const requestTokensAjax$ = ({ email: username, password }) => from(axios.post(
  `${process.env.API_ENDPOINT}/auth/admin-token/request`,
  { username, password }
));